<!--
 * @FileDescription: 未发货商品列表
 * @Author: 陈文景
 * @Date: 2022-12-10 15:18:19
 * @LastEditors: 最后更新作者
 * @LastEditTime: 最后更新时间
-->
<template>
  <div class="content">
    <div class="goods-info">{{ $t('Order.Refund.Mobile.Components.NotShippedGoods.NotShipped') }} ({{ data.length }})</div>

    <template v-if="data.length">
      <el-checkbox :value="checkAll" :indeterminate="isIndeterminate" :disabled="!data.length" @change="handleSelectAll">{{ $t('Order.Refund.Mobile.Components.NotShippedGoods.SelectAll') }}</el-checkbox>
    </template>

    <div>
      <template v-for="(item, index) in data">
        <GoodItem :ref="`goodItem${index}`" :key="item.id" :data="item" @amount="changeCheckedOrQuantity" />
      </template>

      <!-- 空状态 -->
      <template v-if="!data.length">
        <div class="not-data">
          <img src="~@/assets/img/undraw_random_thoughts_re_cob6.svg" alt="img.svg" />
          <span class="tips-text">{{ $t('Order.Refund.Mobile.Components.NotShippedGoods.NoRecord') }}</span>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import GoodItem from './GoodItem.vue'

export default {
  props: {
    // 商品数据
    data: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  components: {
    GoodItem
  },
  watch: {
    data: {
      handler(value) {
        let flag = value.every((item) => item.check === true)
        if (flag) {
          this.checkAll = true
          this.isIndeterminate = false
        } else {
          this.checkAll = false
          if (value.every((item) => item.check === false)) {
            this.isIndeterminate = false
          } else {
            this.isIndeterminate = true
          }
        }
      },
      deep: true
    }
  },
  data() {
    return {
      checkAll: false, // 是否全选
      isIndeterminate: false // 全选按钮的半选中状态
    }
  },
  methods: {
    /**
     * 选择所有
     */
    handleSelectAll(value) {
      this.checkAll = value
      this.isIndeterminate = false
      this.data.forEach((item, index) => {
        if (value) {
          item.quantity = item.productNum
        } else {
          item.quantity = 0
        }
        this.$refs[`goodItem${index}`][0].setNum(item.quantity)
      })
      this.$emit('change', this.checkAll, 2)
    },

    /**
     * 某项复选框被选中或数量发生改变时的事件
     */
    changeCheckedOrQuantity() {
      this.$emit('amount')
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  .goods-info {
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 12px;
  }
  .el-checkbox {
    /deep/.el-checkbox__inner {
      width: 16px;
      height: 16px;
      border-radius: 8px;
      &::after {
        top: 2px;
        left: 5px;
      }
      &::before {
        top: 6px;
      }
    }
  }
  .not-data {
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: space-between;
    img {
      width: 268px;
      margin-bottom: 15px;
    }
    .tips-text {
      color: #7b7b7b;
      font-size: 14px;
      font-weight: 400;
    }
  }
}
</style>
